import {} from 'bootstrap.native';
import initTextVariants from './text-rotator.js';

var elements, i;
elements = document.querySelectorAll('.text-variants');
for (i=0; i<elements.length; i++) initTextVariants(elements[i]);
